/* src/app/modules/shared/components/header-column/header-column-craft-designation/header-column-craft-designation.component.scss */
app-header-column-craft-designation {
  display: contents;
}
/*# sourceMappingURL=header-column-craft-designation.component.css.map */
